<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Arial Bold"><br/><br/><br/><br/><br/><br/><br/>About the Author</h1>
<p><br/><br/>Damian Forest Light is a writer, composer, and performer from New York City. He was honoured as ‘Poet of the Year 2006’ by International Library of Congress. He has an M.A. and studies as a writer and moonlighter, hiking and working throughout the deserts of North America.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0ba78734